import { useMutation } from '@lumapps/base-api/react-query';
import { getAuthorizeUrl } from '@lumapps/connectors/api/connectorsApi';

/**
 * Mutation hook to fetch the authorization URL for a connector.
 */
export const useAuthorizeConnector = () =>
    useMutation({
        mutationFn: async (connectorId: string) => {
            const { data } = await getAuthorizeUrl(connectorId);
            return data;
        },
    });
